import store from '@/store'

let guard = (context) => new Promise((resolve, reject) => {
  if (store.getters['auth/user'] && store.getters['auth/user'].id) {
    resolve()
  } else {
    window.location.replace('https://app.runsnitch.io')
  }
})

export default {
  name: 'auth',
  run: guard
}
